import { render, staticRenderFns } from "./SOPsPage.vue?vue&type=template&id=2fe98a77&scoped=true"
import script from "./SOPsPage.vue?vue&type=script&lang=js"
export * from "./SOPsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe98a77",
  null
  
)

export default component.exports